import IUserAccess from '@shared/models/components/IUserAccess';
import UserDeviceProfileModel from '@shared/models/deviceProfiles/UserDeviceProfileModel';
import UserLicenseAccessModel from '@shared/models/users/UserLicenseAccessModel';

export const isLicensedProfile = (profile?: UserDeviceProfileModel | null) => {
    if (!profile) return false;

    return (
        profile.requiresGenericLicense ||
        profile.requiresEmployeeAccess ||
        profile.requiresStudentAccess ||
        profile.requiresPlusAccess
    );
};

export const isLicenseValidForProfile = (profile: UserDeviceProfileModel, licenseAccess: IUserAccess | undefined) => {
    if (!isLicensedProfile(profile)) return true;

    if (!licenseAccess || licenseAccess.type === 'personal') {
        return false;
    }

    if (!licenseAccess.access.isEmployeeAccess && profile.requiresEmployeeAccess) {
        return false;
    }

    if (!licenseAccess.access.isStudentAccess && profile.requiresStudentAccess) {
        return false;
    }

    if (!licenseAccess.access.isPlusAccess && profile.requiresPlusAccess) {
        return false;
    }

    // profile has generic license or specific profile license
    return true;
};
